export function getSortingPath(path: string[]) {
  return path.map(name => ({ name }));
}
